module.exports = __webpack_public_path__ + "static/one-percent-courtesy_bg-b036a6cab6c9ff1d39fa4aa886a3bfd7.jpg";